import { useDispatch } from 'react-redux';
import { showSnackbar } from '../api/snackbarSlice';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import logo from '../assets/logo/marmin_logo.png';
import { apiClient } from '../utils/axios';

function RequestEInvoiceSearchForm() {
  const dispatch = useDispatch();
  const { businessId } = useParams();
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const navigate = useNavigate();
  const [logoImg, setLogoImg] = useState(logo);

  useEffect(() => {
    if (!businessId) {
      dispatch(showSnackbar({ message: 'Business ID is required.', severity: 'error' }));
    } else {
      apiClient
        .get(`/business-profiles/${businessId}/logo`)
        .then((res) => {
          if (res.data.logo_url) {
            setLogoImg(res.data.logo_url);
          }
        })
        .catch((err) => {
          dispatch(
            showSnackbar({
              message: err?.response?.data?.errors?.message ?? 'Something went wrong.',
              severity: 'error',
            }),
          );
        });
    }
  }, [businessId, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/invoices/${invoiceNumber}/consolidate?businessId=${businessId}`,
      );
      if (!response.ok) {
        navigate(`/request-e-invoice/${businessId}/error`);
      } else {
        const data = await response.json();
        navigate(`/request-e-invoice/${businessId}/customer-info`, { state: { data } });
      }
    } catch (error) {
      console.error('Error fetching invoice:', error);
      dispatch(showSnackbar({ message: 'An error occurred while fetching the invoice.', severity: 'error' }));
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
      <Grid xs={12}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img src={logoImg} alt="Marmin Logo" style={{ maxWidth: '250px', maxHeight: '150px' }} />
        </Box>
        <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
          Request E-Invoice
        </Typography>
        <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={2}>
          <Box display="flex" alignItems="center" gap={4}>
            <TextField
              variant="outlined"
              label="Invoice/Receipt Number"
              fullWidth
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
          </Box>
          <Button variant="contained" color="primary" type="submit">
            Get Invoice/Receipt
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default RequestEInvoiceSearchForm;
